import { useDispatch, useSelector } from 'react-redux'
import { motion, AnimatePresence } from 'framer-motion'

// Actions
import { actions } from 'modules/notifications/actions'

// Components
import { Notification } from 'kit'

// Selectors
import { unseenNotificationSelector } from 'modules/notifications/selectors'

// Types
import { State } from 'types'

// Utils
import { DEFAULT_EASE } from '@constants'

import styles from './notifications.css'

export const AnimatedNotification = motion(Notification)

const Notifications = (): JSX.Element => {
  const dispatch = useDispatch()
  const markAsSeen = (notification: Notification) => () => dispatch(actions.markAsSeen(notification))
  const state = useSelector<State, State>(s => s)
  const notifications = unseenNotificationSelector(state)
  return (
    <div className={styles.wrapper}>
      <AnimatePresence>
        {notifications.map(n => (
          <AnimatedNotification
            initial={{
              y: -3000,
              opacity: 0,
            }}
            animate={{
              y: 0,
              opacity: 1,
              transition: { duration: 0.5, ease: DEFAULT_EASE },
            }}
            exit={{
              y: -10,
              opacity: 0,
              transition: { duration: 0.4, ease: DEFAULT_EASE },
            }}
            layout
            transition={{
              type: 'spring',
              stiffness: 300,
              mass: 0.5,
              damping: 20,
            }}
            notification={n}
            onSeen={markAsSeen(n)}
            key={`local${n.localId || ''}` || n.id}
          />
        ))}
      </AnimatePresence>
    </div>
  )
}

export default Notifications
